import ApplyButton from "../components/ApplyButton";
import { Reveal } from "../components/Reveal";
import { Search, FileCheck, Truck, RefreshCw } from "lucide-react";

const steps = [
  { icon: Search, title: "Pick your iPhone", body: "Browse our catalog of certified like-new iPhones — unlocked and carrier-specific options for every budget." },
  { icon: FileCheck, title: "Apply with Payvantage", body: "Complete a quick application through the Payvantage leasing program. Checking your eligibility won't affect your credit score." },
  { icon: Truck, title: "Get it shipped free", body: "Once approved, your PhoneCheck-certified device ships free via UPS, ready to use out of the box." },
  { icon: RefreshCw, title: "Lease-to-own", body: "Make simple, flexible payments over time. Choose an early buyout or keep paying toward ownership — your call." },
];

export default function HowItWorks() {
  return (
    <div className="pt-32" data-testid="how-it-works-page">
      <section className="mx-auto max-w-7xl px-6 pb-16 lg:px-12">
        <Reveal>
          <span className="text-sm font-bold uppercase tracking-widest text-crimson">How leasing works</span>
          <h1 className="mt-3 max-w-3xl font-display text-5xl font-black leading-none tracking-tighter text-ink sm:text-6xl">
            Own the iPhone you want, <span className="text-crimson">without the upfront hit.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg text-muted-foreground">
            Four simple steps from browsing to unboxing. No hidden fees, no credit-score damage just to check.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-24 lg:px-12">
        <div className="space-y-4">
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div
                data-testid={`step-${i + 1}`}
                className={`relative grid items-center gap-6 overflow-hidden rounded-3xl border border-line bg-white p-8 md:grid-cols-[auto_1fr] md:p-12 ${i % 2 === 1 ? "md:ml-16" : "md:mr-16"}`}
              >
                <span className="pointer-events-none absolute -right-4 -top-10 font-display text-[10rem] font-black leading-none text-alt select-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="relative z-10 flex h-16 w-16 items-center justify-center rounded-2xl bg-crimson/10">
                  <s.icon className="h-7 w-7 text-crimson" />
                </div>
                <div className="relative z-10">
                  <h3 className="font-display text-2xl font-bold tracking-tight text-ink">{s.title}</h3>
                  <p className="mt-2 max-w-2xl text-base leading-relaxed text-muted-foreground">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16 flex flex-col items-start gap-6 rounded-3xl bg-surface-dark p-10 text-white md:flex-row md:items-center md:justify-between md:p-14">
            <div>
              <h2 className="font-display text-3xl font-black tracking-tighter">Ready to start your lease?</h2>
              <p className="mt-2 text-white/60">It only takes a few minutes to apply through Payvantage.</p>
            </div>
            <ApplyButton testId="how-apply-btn" />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
